<template>
	<sa-page-layout ref="cmpSaPageLayout" :btnRouterBackVisible="true" :btnBackVisible="false" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
		<template slot="toolbar">
			<b-button class="my-2 my-sm-0" variant="outline-purple btn-toolbar sa-margin-left float-sm-left" @click="onClickCambiaStatoTask"><i class="fas fa-exchange-alt"></i>Cambia Stato </b-button>
			<b-button class="my-2 my-sm-0" variant="outline-success btn-toolbar sa-margin-left float-sm-left" :disabled="btnPresaInCaricoDisabled" @click="onClickPresaInCaricoTask">
				<b-icon icon="plus" aria-hidden="true"></b-icon>
				Presa In Carico
			</b-button>
		</template>
		<template slot="table-header">
			<gestione-attivita-task-view-component ref="cmpGestioneAttivitaTaskViewComponent" @updateJsonData="onUpdateJsonDataTask"></gestione-attivita-task-view-component>
		</template>
		<template slot="table-body">
			<b-tabs id="tbasRsaRefertiList" ref="tbasRsaRefertiList" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
				<b-tab active>
					<template #title><i class="fas fa-code"></i><span style="padding-left: 10px">Lavoro</span></template>
					<gestione-attivita-tasks-lavoro-dipendente-list-component
						ref="cmpGestioneAttivitaTasksLavoroDipendenteListComponent"
						@update="onUpdateGestioneAttivitaTasksLavoroDipendenteListComponent"
						@afterLoadData="onAfterLoadDataGestioneAttivitaTasksLavoroDipendenteListComponent"
					></gestione-attivita-tasks-lavoro-dipendente-list-component>
				</b-tab>

				<!-- <b-tab>
					<template #title> <b-spinner type="border" small></b-spinner> Progetti </template>
					<p class="p-3">Tab contents 2</p>
				</b-tab> -->
				<b-modal title="Nuova Task" ref="mdlEditTask" id="mdlEditTask" size="xl" @shown="onShownNuovoTask" @ok="onOkEditTask">
					<!-- <gestione-attivita-task-edit-component ref="cmpGestioneAttivitaTaskEditComponent"></gestione-attivita-task-edit-component> -->
				</b-modal>
				<b-modal ref="mdlPresaInCaricoTask" size="sm" title="Fine Attività" @ok="onOkPresaInCaricoTask">
					<date-picker format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="dataOraInizioTask" type="datetime"></date-picker>
				</b-modal>
				<modal-error ref="cmpModalError"></modal-error>
				<state-change-modal-component ref="cmpStateChangeModalComponent" @cambioStatoSuccess="onCambioStatoSuccess"></state-change-modal-component>
			</b-tabs>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import GestioneAttivitaTaskViewComponent from "../components/GestioneAttivitaTaskViewComponent.vue";
import GestioneAttivitaTasksLavoroDipendenteListComponent from "../components/GestioneAttivitaTasksLavoroDipendenteListComponent.vue";
import DatePicker from "vue2-datepicker";
import StateChangeModalComponent from "../../utility/components/StateChangeModalComponent.vue";
// import GestioneAttivitaTaskEditComponent from "../components/GestioneAttivitaTasksEditComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
	mixins: [UtilityMixin],
	components: { SaPageLayout, ModalError, GestioneAttivitaTaskViewComponent, GestioneAttivitaTasksLavoroDipendenteListComponent, StateChangeModalComponent, DatePicker },
	data() {
		return {
			idTask: null,
			activeTabIndex: 0,
			btnSaveVisible: true,
			showModalLoading: false,
			linkback: "/gestioneattivita/tasks",
			pathResource: "/gestioneattivitaattivita",
			pathResourceTasks: "/gestioneattivitatasks",
			pathResourcePresaInCaricoTask: "/gestioneattivitatasklavorodipendente",
			pathResourceStatiTask: "/gestioneattivitastati",
			pathResourceAggiornaStato: "/gestioneattivitatasksstatistorico",
			jsonData: null,
			dataOraInizioTask: null,
			btnPresaInCaricoDisabled: true,
		};
	},
	mounted() {
		this.idTask = this.$route.params.id;
		this.$refs.cmpGestioneAttivitaTasksLavoroDipendenteListComponent.init({ idTask: this.idTask });
	},
	methods: {
		onUpdateJsonDataTask(jsonData) {
			this.jsonData = jsonData;
			this.btnPresaInCaricoDisabled = true;
			if (this.jsonData.statoAttuale === "SOSPESO" || this.jsonData.statoAttuale === "IN LAVORAZIONE") {
				this.btnPresaInCaricoDisabled = false;
			}
		},
		onInputTabs() {},
		onClickPresaInCaricoTask() {
			let me = this;
			me.dataOraInizioTask = new Date().getTime();
			me.$refs.mdlPresaInCaricoTask.show();
		},
		onShownNuovoTask() {
			// let me = this;
			// me.$refs.cmpGestioneAttivitaTaskEditComponent.init({ idAttivita: me.jsonData.id, idTask: "-1" });
		},
		onOkEditTask(bvModalEvt) {
			let me = this;
			bvModalEvt.preventDefault();
			let jsonDataTask = me.$refs.cmpGestioneAttivitaTaskEditComponent.getJsonDataTask();
			UtilityMixin.methods.saveResource(me.pathResourceTasks, jsonDataTask, me.saveTaskSuccess, me.saveTaskError);
		},
		saveTaskSuccess() {
			let me = this;
			me.$refs.mdlEditTask.hide();
			this.$refs.cmpGestioneAttivitaTaskListComponent.init({ idAttivita: this.idAttivita });
		},
		saveTaskError(error) {
			let me = this;
			me.$refs.cmpModalError.show(error.response.data.messaggio);
		},
		onOkPresaInCaricoTask() {
			let me = this;
			let body = { idTask: me.jsonData.id, dataOraInizio: me.dataOraInizioTask };
			let link = process.env.VUE_APP_PATH_API + me.pathResourcePresaInCaricoTask;
			me.showModalLoading = true;
			UtilityMixin.methods.restCallPost(link, body, me.presaInCaricoTaskSuccess, me.presaInCaricoTaskErrors);
		},
		presaInCaricoTaskSuccess() {
			this.$refs.cmpGestioneAttivitaTaskViewComponent.loadData();
			this.$refs.cmpGestioneAttivitaTasksLavoroDipendenteListComponent.init({ idTask: this.idTask });
			this.showModalLoading = false;
		},
		presaInCaricoTaskErrors(error) {
			this.$bvModal
				.msgBoxOk(error.response.data.messaggio, {
					title: "ATTENZIONE",
					size: "sm",
					okVariant: "outline-danger",
					headerClass: "sa-msg-header-danger",
					footerClass: "p-2 border-top-0",
					centered: true,
				})
				.then((value) => {
					console.log(value);
				})
				.catch((err) => {
					console.log(err);
				});
			this.showModalLoading = false;
		},
		onUpdateGestioneAttivitaTasksLavoroDipendenteListComponent() {
			this.$refs.cmpGestioneAttivitaTaskViewComponent.loadData();
			this.$refs.cmpGestioneAttivitaTasksLavoroDipendenteListComponent.init({ idTask: this.idTask });
		},
		onClickCambiaStatoTask() {
			this.$refs.cmpStateChangeModalComponent.show({ idTask: this.idTask }, this.pathResourceStatiTask, this.pathResourceAggiornaStato);
		},
		onCambioStatoSuccess() {
			this.$refs.cmpGestioneAttivitaTaskViewComponent.loadData();
			this.$refs.cmpGestioneAttivitaTasksLavoroDipendenteListComponent.init({ idTask: this.idTask });
			this.showModalLoading = false;
		},
		onAfterLoadDataGestioneAttivitaTasksLavoroDipendenteListComponent() {},
	},
};
</script>

<style></style>
